<template>
	<Tooltip
		textAlign_prop="left"
		textPosition_prop="bottom-right"
		maxWidth_prop="max-w-100 text-xs"
		iconHeight_prop="0.75rem"
		iconWidth_prop="0.75rem"
		:iconColor_prop="colorGrey8"
		tooltipClass_prop="p-5"
	>
		<div v-if="$store.getters.paymentMethod == 'gopay'">
			<div class="font-semibold">Contract Value</div>
			<div class="font-normal mb-3">
				Total Contract Price × Quantity before order execution
			</div>

			<div class="font-semibold">Fee</div>
			<div class="font-normal mb-3">1% of Contract Value (min. Rp500)</div>

			<div class="font-semibold">Tax</div>
			<div class="font-normal mb-3">11% of Fee</div>

			<div v-if="$store.getters.paymentMethod == 'rped'">
				<div class="font-semibold">
					Total {{ direction == "buy" ? "Buy" : "Sell" }} Order
				</div>
				<div v-if="direction == 'buy'" class="font-normal mb-3">
					Total of Contract Value + Fee + Tax
				</div>
				<div v-if="direction == 'sell'" class="font-normal mb-3">
					Total of Contract Value - Fee - Tax
				</div>
			</div>

			<div v-if="direction == 'buy'" class="font-semibold">FX Buffer</div>
			<div v-if="direction == 'buy'" class="font-normal mb-3">
				Pricing is in USD as it follows the international gold market. An FX
				Buffer in e-wallet balance is included to anticipate exchange rate
				fluctuations and is only used if currency changes affect the Executed
				Total Payment (Settlement Amount)
			</div>

			<div v-if="direction == 'sell'" class="font-semibold">Storage Fee</div>
			<div v-if="direction == 'sell'" class="font-normal mb-3">
				Storage fee is charged to traders for holding physical gold at a rate of
				2% per annum, calculated proportionally based on the holding period
				(number of days/365). This fee will be deducted from the gold sale
				proceeds (Amount Received)
			</div>

			<div v-if="$store.getters.paymentMethod == 'gopay'">
				<div class="font-semibold">
					Total {{ direction == "buy" ? "Buy" : "Sell" }} Order
				</div>
				<div v-if="direction == 'buy'" class="font-normal mb-3">
					Total of Contract Value + Fee + Tax + FX Buffer
				</div>
				<div v-if="direction == 'sell'" class="font-normal mb-3">
					Total of Contract Value - Fee - Tax - Storage Fee
				</div>
			</div>

			<div v-if="$store.getters.paymentMethod == 'gopay'" class="font-semibold">
				Admin Fee
			</div>
			<div
				v-if="$store.getters.paymentMethod == 'gopay'"
				class="font-normal mb-3"
			>
				Fees charged for processing order using an e-wallet
				<br />
				<div v-if="direction == 'buy'">
					<ul class="pl-5">
						<li>
							Admin Fee (2%) is charged based on the Total Buy Order value
							before the order is execution
						</li>
						<li>
							If the Total Buy Order changes after the order is executed (due to
							foreign exchange fluctuations), the 2% Admin Fee will still be
							calculated based on the Total Buy Order + FX Buffer before
							execution
						</li>
					</ul>
				</div>
				<div v-else>
					<ul class="pl-5">
						<li>
							An admin fee of Rp2,500 is charged for each order that is
							successfully executed. If a partial order occurs due to market
							conditions, the admin fee will be charged for each exec
						</li>
					</ul>
				</div>
			</div>

			<div v-if="direction == 'sell'" class="font-semibold">
				Estimated Amount Received
			</div>
			<div
				v-if="direction == 'sell' && $store.getters.paymentMethod == 'rped'"
				class="font-normal mb-3"
			>
				Total of Total Sell Order - Storage Fee - Admin Fee
			</div>
			<div
				v-if="direction == 'sell' && $store.getters.paymentMethod == 'gopay'"
				class="font-normal mb-3"
			>
				Total of Total Sell Order - Admin Fee
			</div>
		</div>

		<div v-else>
			<MarkdownRenderer
				:content="$store.state.glossaries.orderDetails.body"
			/>
		</div>
	</Tooltip>
</template>

<script>
	import MarkdownRenderer from "../MarkdownRenderer.vue"
	import Tooltip from "../Tooltip.vue"

	export default {
		name: "TooltipRincianOrder",
		props: ["direction"],
		components: {
			Tooltip,
			MarkdownRenderer,
		},

		data() {
			return {
				colorGrey8: getComputedStyle(document.documentElement).getPropertyValue(
					"--color-grey8",
				),
			}
		},

		created() {
			if (!this.$store.state.glossaries.orderDetails.body) {
				this.$store.dispatch("glossaries/setOrderDetails")
			}
		},
	}
</script>
